import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export function NotFoundPage() {
  return (
    <>
      <Seo
        title="Not found"
        description="This page is not on jayvanzyl.me."
        path="/404"
      />
      <section className="wrap section" style={{ paddingTop: "4.5rem" }}>
        <p className="eyebrow">404</p>
        <h1>This page is not here</h1>
        <p>
          Try <Link to="/">home</Link>, <Link to="/work">projects</Link>, or{" "}
          <Link to="/thinking">thinking</Link>.
        </p>
      </section>
    </>
  );
}
